import Avatar, { AvatarProps, avatarClasses } from '@mui/material/Avatar';
import Badge, { BadgeProps, badgeClasses } from '@mui/material/Badge';
import Typography, {
  TypographyProps,
  typographyClasses,
} from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { ICustomTheme } from '~/styles/theme';

export const AVATAR_SIZE = 110;
const AVATAR_SIZE_SMALL = 35;

export const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  [`&.${badgeClasses.root}`]: {
    cursor: 'pointer',
    position: 'absolute',
    top: `calc(100% - ${AVATAR_SIZE / 2}px)`,
    zIndex: theme.zIndex.appBar + 1,
  },
}));

export const StyledAvatarSmall = styled(Avatar)<AvatarProps>(({ theme }) => ({
  [`&.${avatarClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
    border: `2px solid ${theme.palette.primary.main}`,
    height: AVATAR_SIZE_SMALL,
    marginRight: AVATAR_SIZE * 2.5,
    width: AVATAR_SIZE_SMALL,
  },
}));

export const StyledTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      cursor: 'pointer',
      marginRight: `calc(${AVATAR_SIZE}px + ${theme.spacing(1)})`,
    },
  }),
);

export const StyledContentContainer = styled('main')(({ theme }) => ({
  height: `calc(100% - ${(theme as unknown as ICustomTheme).customDims.heights.header}px)`,
  marginTop: 2,
}));
